import { render, staticRenderFns } from "./environmentallist.vue?vue&type=template&id=564e80cd&scoped=true&"
import script from "./environmentallist.vue?vue&type=script&lang=js&"
export * from "./environmentallist.vue?vue&type=script&lang=js&"
import style0 from "./environmentallist.vue?vue&type=style&index=0&id=564e80cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e80cd",
  null
  
)

export default component.exports